'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _customRenderer = require('UIComponents/utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _createLazyPropType = require('UIComponents/utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _lazyEval = require('UIComponents/utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'SingleNameInput',

  propTypes: {
    input: CustomRenderer.propType.isRequired,
    label: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired
  },

  render: function render() {
    var _props = this.props,
        className = _props.className,
        input = _props.input,
        label = _props.label,
        passThroughProps = _objectWithoutProperties(_props, ['className', 'input', 'label']);

    var inputClass = input.props && input.props.className;
    return CustomRenderer.render(input, _extends({
      label: (0, _lazyEval2.default)(label)
    }, passThroughProps, input.props, {
      className: (0, _classNames2.default)(inputClass, className)
    }), {
      mergeType: 'aggressive'
    });
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.1352/js/internal/components/SingleNameInput.js
// module id = 482
// module chunks = 0